import { EmailLink, PersonNameTableCell, WhatsAppLink } from '@repo/ui';
import { PERSONS_ORDER_COLUMN } from 'domain/value-objects/persons-order-column';
import { StudentData } from 'domain/value-objects/student-data';
import { TableColumn } from 'react-data-table-component';

export const makeColumnsStudentsList = (): TableColumn<StudentData>[] => {
  return [
    {
      name: 'Nome',
      wrap: true,
      width: '450px',
      sortable: true,
      sortField: PERSONS_ORDER_COLUMN.NAME,
      cell: (row) => (
        <PersonNameTableCell
          name={row.name}
          imgSrc={row.avatar}
          cpf={row.cpf}
        />
      ),
    },
    {
      name: 'Telefone',
      width: '250px',
      sortable: true,
      sortField: PERSONS_ORDER_COLUMN.PHONE,
      cell: (row) =>
        row.phone ? <WhatsAppLink telephone={row.phone} /> : <></>,
    },
    {
      name: 'Email',
      wrap: true,
      width: '300px',
      sortable: true,
      sortField: PERSONS_ORDER_COLUMN.EMAIL,
      cell: (row) => <EmailLink email={row.email} />,
    },
  ];
};
